import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import Axios, { authHeaders } from "../../utils/axios";
import { toast } from "../../context/TostContext";

export const fetchProfessions = createAsyncThunk(
    "profession/fetchProfessions",
    async (params, { rejectWithValue }) => {
        try {
            const { page, limit, search } = params || {};
            const queryParams = new URLSearchParams({
                page: page || 1,
                limit: limit || 10,
                search: search || ""
            });
            const response = await Axios.get(`/professions?${queryParams.toString()}`, authHeaders());
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response?.data?.message || error.message);
        }
    }
);

export const createProfession = createAsyncThunk(
    "profession/create",
    async (data, { rejectWithValue }) => {
        try {
            const response = await Axios.post("/professions", data, authHeaders());
            toast.success(response.data.message || "Profession created successfully");
            return response.data;
        } catch (error) {
            toast.error(error.response?.data?.message || error.message);
            return rejectWithValue(error.response?.data?.message || error.message);
        }
    }
);

export const updateProfession = createAsyncThunk(
    "profession/update",
    async ({ id, data }, { rejectWithValue }) => {
        try {
            const response = await Axios.put(`/professions/${id}`, data, authHeaders());
            toast.success(response.data.message || "Profession updated successfully");
            return response.data;
        } catch (error) {
            toast.error(error.response?.data?.message || error.message);
            return rejectWithValue(error.response?.data?.message || error.message);
        }
    }
);

export const toggleProfessionStatus = createAsyncThunk(
    "profession/toggleStatus",
    async ({ id, is_active }, { rejectWithValue }) => {
        try {
            const response = await Axios.put(`/professions/${id}`, { is_active }, authHeaders());
            toast.success(response.data.message || "Status updated successfully");
            return { id, is_active, data: response.data };
        } catch (error) {
            toast.error(error.response?.data?.message || error.message);
            return rejectWithValue(error.response?.data?.message || error.message);
        }
    }
);

export const deleteProfession = createAsyncThunk(
    "profession/delete",
    async (id, { rejectWithValue }) => {
        try {
            const response = await Axios.delete(`/professions/${id}`, authHeaders());
            toast.success(response.data.message || "Profession deleted successfully");
            return id;
        } catch (error) {
            toast.error(error.response?.data?.message || error.message);
            return rejectWithValue(error.response?.data?.message || error.message);
        }
    }
);

const professionSlice = createSlice({
    name: "profession",
    initialState: {
        list: [],
        pagination: { total: 0, page: 1, limit: 10 },
        isLoading: false,
        error: null,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchProfessions.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(fetchProfessions.fulfilled, (state, action) => {
                state.isLoading = false;
                state.list = action.payload.data || [];
                state.pagination = action.payload.meta || state.pagination;
            })
            .addCase(fetchProfessions.rejected, (state, action) => {
                state.isLoading = false;
                state.error = action.payload;
            })
            .addCase(deleteProfession.fulfilled, (state, action) => {
                state.list = state.list.filter((item) => item.id !== action.payload);
            })
            .addCase(toggleProfessionStatus.fulfilled, (state, action) => {
                const { id, is_active } = action.payload;
                const profession = state.list.find((item) => item.id === id);
                if (profession) {
                    profession.is_active = is_active;
                }
            });
    },
});

export default professionSlice.reducer;
